import { render } from "./CInputRadio.vue?vue&type=template&id=ba374ea2"
import script from "./CInputRadio.vue?vue&type=script&lang=js"
export * from "./CInputRadio.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__